import { useEffect, useState } from 'react';

import NxtbnModal from '../Modal';
import useApi from "../../api";
import { NXForm } from "../common";
import { handleRetriveError } from "../../utils";
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from "../../redux/rootReducer";
import { fetchWarehouse } from "../../redux/warehosueSlice";
import { makeEnumFriendly } from '../../enum';
import TransferReservationAction from './TransferReservationAction';
import OrderDetails from '../orders/orderDetails';

interface TransferReservationProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
  variant?: any;
}

function TransferReservation({ isOpen, onClose, onSubmit, variant }: TransferReservationProps) {
  const [formData, setFormData] = useState<any>([]);
  const [errorData, setErrorData] = useState<any>({});
  const [openOrderDetails, setOpenOrderDetails] = useState('');


  const dispatch = useDispatch();
  const warehouse = useSelector((state: RootState) => state.warehouse);

  const api = useApi();


  const fetchReservation = () =>  {
    if (variant) {
      const params = {
        variant: variant,
      }
      api.getStockReservationList(params).then(
        (response: any) => {
            setFormData(response.results);
        }, handleRetriveError);
    }
  }

  useEffect(() => {
    fetchReservation();
   
  }, []);



  const fetchData = () => {
    if (!warehouse.results.length){
      dispatch(fetchWarehouse() as any);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <NxtbnModal size='xxl' isOpen={isOpen} onClose={onClose}>
      <NXForm
        onSubmit={() => ({})}
        className="p-6"
        title="Stock Reservation Warehouse Wise"
        nonFieldError={{}}
      >
        <div className="mt-4">
            <p className="text-sm text-gray-500">
              Note: Use the reservation transfer feature only when a consolidated delivery is required. If the delivery is directly from the warehouse, reservation transfer is not necessary.
            </p>
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Warehouse
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Purpose
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Reserved
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Order
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Destination WH
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  ...
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {formData.map((item: any, index: number) => (
                <tr key={index}>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {item.stock.warehouse_name}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {item.purpose}
                  </td>                 
                  <td className="px-6 py-4 whitespace-nowrap">
                    <p>{item.quantity}</p>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <a 
                      onClick={() => setOpenOrderDetails(item.order.order_alias)} 
                      className='cursor-pointer text-blue-500 hover:underline'
                    >
                      #OID-{item.order.order_id}
                    </a>
                  </td>
                  <TransferReservationAction
                    options={makeEnumFriendly(warehouse.results)}
                    reservation={item.id}
                    onUpdate={fetchReservation}
                  />
                 </tr>
                ))}
            </tbody>
          </table>
        </div>

        <div className="mt-6 flex justify-end">
          <button
            type="button"
            onClick={onClose}
            className="mr-3 inline-flex justify-center rounded-md border border-transparent px-4 py-2 bg-gray-600 text-base font-medium text-white shadow-sm hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
          >
            Close
          </button>
        </div>
      </NXForm>

      <OrderDetails
        isOpen={openOrderDetails ? true : false}
        onClose={() => setOpenOrderDetails('')}
        alias={openOrderDetails}
      />
    </NxtbnModal>
  );
}

export default TransferReservation;
